import React, { Component } from "react";
require("@/styles/schedule.less");
import ScheduleItem from "./ScheduleItem";

class Schedule extends Component<{ nextweek?: boolean }> {
  state = {
    schedule: [],
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
    week: "",
    selected: null
  };
  getText = (text) => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(text, "text/html")
    return doc.documentElement.textContent
  }
  select = (show) => {
    this.setState({selected: show})
  }
  componentDidMount() {
    const {nextweek = false} = this.props;
    if (nextweek){
      this.setState({
        week: "next"
      })
    }
    fetch("https://backend.purpleradio.co.uk/api/live-info-v2")
      .then((res1) => res1.json())
      .then((data1) => {
        fetch("https://backend.purpleradio.co.uk/api/week-info")
          .then((res) => res.json())
          .then((data) => {
            this.setState({
              schedule: data,
              monday: data?.[this.state.week + "monday"].map((val) => {
                return (
                  <ScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"monday"}
                    currentTime={data1?.["station"]["schedulerTime"]}
                    setSelected={this.select}
                  />
                );
              }),
              tuesday: data?.[this.state.week + "tuesday"].map((val) => {
                return (
                  <ScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"tuesday"}
                    currentTime={data1?.["station"]["schedulerTime"]}
                    setSelected={this.select}
                  />
                );
              }),
              wednesday: data?.[this.state.week + "wednesday"].map((val) => {
                return (
                  <ScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"wednesday"}
                    currentTime={data1?.["station"]["schedulerTime"]}
                    setSelected={this.select}
                  />
                );
              }),
              thursday: data?.[this.state.week + "thursday"].map((val) => {
                return (
                  <ScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"thursday"}
                    currentTime={data1?.["station"]["schedulerTime"]}
                    setSelected={this.select}
                  />
                );
              }),
              friday: data?.[this.state.week + "friday"].map((val) => {
                return (
                  <ScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"friday"}
                    currentTime={data1?.["station"]["schedulerTime"]}
                    setSelected={this.select}
                  />
                );
              }),
              saturday: data?.[this.state.week + "saturday"].map((val) => {
                return (
                  <ScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"saturday"}
                    currentTime={data1?.["station"]["schedulerTime"]}
                    setSelected={this.select}
                  />
                );
              }),
              sunday: data?.[this.state.week + "sunday"].map((val) => {
                return (
                  <ScheduleItem
                    key={val.start_timestamp}
                    details={val}
                    day={"sunday"}
                    currentTime={data1?.["station"]["schedulerTime"]}
                    setSelected={this.select}
                  />
                );
              }),
            });
          });
      })
  }
  render() {
    return (
      <div className="schedulecontainer">
        {this.state.selected ? <div className="details-background" onClick={() => this.setState({selected: null})}>
          <div className="details-panel">
            <div className="details-exit" onClick={() => this.setState({selected: null})} >
              X
            </div>
            <div className="details-content">
                {this.state.selected?.image_path != "" ? 
                <div className="details-frame">
                  <div className="details-image" style={{backgroundImage: `url(${this.state.selected?.image_path})`}}/>
                </div> : null}
                <div className="details-text">
                    <h3 className="title">{this.getText(this.state.selected?.name)}</h3>
                    <h4 className="time">{this.state.selected?.starts.slice(11, 16)} - {this.state.selected?.ends.slice(11, 16)}</h4>
                    <div>
                      {this.getText(this.state.selected?.description)}
                    </div>
                </div>
            </div>
          </div>
        </div> : null}
        
        <div className="schedule-main" id="main" style={{"paddingLeft": "15%", "paddingRight": "15%"}}>
          <div
            className="schedule-day"
            id="list_mon"
            style={{ backgroundColor: "#00000050" }}
          >
            <div className="col daycont" style={{ backgroundColor: "#682d91" }}>
              <h2 className="weekday">MON</h2>
            </div>
            {this.state.monday}
          </div>
          <div className="row marginrow"></div>
          <div
            className="schedule-day"
            id="list_tue"
            style={{ backgroundColor: "#00000050" }}
          >
            <div className="col daycont" style={{ backgroundColor: "#742b90" }}>
              <h2 className="weekday">TUES</h2>
            </div>
            {this.state.tuesday}
          </div>
          <div className="row marginrow"></div>
          <div
            className="schedule-day"
            id="list_wed"
            style={{ backgroundColor: "#00000050" }}
          >
            <div className="col daycont" style={{ backgroundColor: "#7e2a90" }}>
              <h2 className="weekday">WEDS</h2>
            </div>
            {this.state.wednesday}
          </div>
          <div className="row marginrow"></div>
          <div
            className="schedule-day"
            id="list_thu"
            style={{ backgroundColor: "#00000050" }}
          >
            <div className="col daycont" style={{ backgroundColor: "#842990" }}>
              <h2 className="weekday">THUR</h2>
            </div>
            {this.state.thursday}
          </div>
          <div className="row marginrow"></div>
          <div
            className="schedule-day"
            id="list_fri"
            style={{ backgroundColor: "#00000050" }}
          >
            <div className="col daycont" style={{ backgroundColor: "#8a288f" }}>
              <h2 className="weekday">FRI</h2>
            </div>
            {this.state.friday}
          </div>
          <div className="row marginrow"></div>
          <div
            className="schedule-day"
            id="list_sat"
            style={{ backgroundColor: "#00000050" }}
          >
            <div className="col daycont" style={{ backgroundColor: "#90278f" }}>
              <h2 className="weekday">SAT</h2>
            </div>
            {this.state.saturday}
          </div>
          <div className="row marginrow"></div>
          <div
            className="schedule-day"
            id="list_sun"
            style={{ backgroundColor: "#00000050" }}
          >
            <div className="col daycont" style={{ backgroundColor: "#92278f" }}>
              <h2 className="weekday">SUN</h2>
            </div>
            {this.state.sunday}
          </div>
          <div className="row marginrow"></div>
        </div>
      </div>
    );
  }
}

export default Schedule;
